import {
    _axios as request
} from "../../plugins/axios";

const actions = {
    //上传文件
    uploadQualification(_,data){
        return new Promise((resolve, reject) => {
            request({
                url: '/file/uploadQualificationDocument',
                method: 'post',
                data: data,
                // headers: {
                //     'Content-Type': 'multipart/form-data'
                // }
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
//    获取资质列表
    getQualificationList(_, data){
        return new Promise((resolve, reject) => {
            request({
                url: '/qualification/searchByStatusAndTypeAndKey',
                method: 'post',
                params: data,
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
//    新增资质
    addQualification(_, data){
        return new Promise((resolve, reject) => {
            request({
                url: '/qualification/add',
                method: 'post',
                data: data,
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
//    编辑资质
    modifyQualification(_, data){
        return new Promise((resolve, reject) => {
            request({
                url: '/qualification/modify',
                method: 'post',
                data: data,
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
//    资质删除
    deleteQualification(_, data){
        return new Promise((resolve, reject) => {
            request({
                url: '/qualification/delete',
                method: 'post',
                params: data,
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
//    获取资质类别列表
    getQualificationTypes(){
        return new Promise((resolve, reject) => {
            request({
                url: '/qualification/getTypeList',
                method: 'post',
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
//    拒绝的资质，重新编辑再提交
    requestRecheckQualification(_, data){
        return new Promise((resolve, reject) => {
            request({
                url: '/qualification/requestRecheck',
                method: 'post',
                params: data
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
//    通过资质审核
    passPending(_, data){
        return new Promise((resolve, reject) => {
            request({
                url: '/qualification/passPending',
                method: 'post',
                params: data
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
//    驳回资质
    rejectPending(_, data){
        return new Promise((resolve, reject) => {
            request({
                url: '/qualification/rejectPending',
                method: 'post',
                params: data
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }
}

export default {
    namespaced: true,
    actions,
}
